import { Navigate, Route, Routes } from "react-router-dom";
import { Shell } from "../components/Shell";
import { getAdminRole, getAdminToken, portalHome, type PortalRole } from "../lib/auth";
import { Content } from "../pages/Content";
import { Exports } from "../pages/Exports";
import { FormBuilder } from "../pages/FormBuilder";
import { ContentTranslation } from "../pages/ContentTranslation";
import { Login } from "../pages/Login";
import { ModuleRedirect } from "../pages/ModuleRedirect";
import { Overview } from "../pages/Overview";
import { PDDayDetail } from "../pages/PDDayDetail";
import { PDDays } from "../pages/PDDays";
import { PDSessions } from "../pages/PDSessions";
import { QuizBuilder } from "../pages/QuizBuilder";
import { SupportTickets } from "../pages/SupportTickets";
import { Centres, Districts, Schools, Structure } from "../pages/Structure";
import { ActivityLog } from "../pages/ActivityLog";
import { AdminAccounts, Facilitators, Teachers } from "../pages/Users";
import { ProtectedRoute } from "./ProtectedRoute";

type PortalRoutesProps = {
  assignedID: string;
  onLogin: (value: { token: string; assignedID: string; role: PortalRole }) => void;
  onLogout: () => void;
};

export function PortalRoutes({ assignedID, onLogin, onLogout }: PortalRoutesProps) {
  const isSuperAdmin = getAdminRole() === "super_admin";
  return (
    <Routes>
      <Route
        path="/login"
        element={
          getAdminToken() && getAdminRole() ? (
            <Navigate to={portalHome()} replace />
          ) : (
            <Login onLogin={onLogin} />
          )
        }
      />
      <Route
        element={
          <ProtectedRoute>
            <Shell assignedID={assignedID} onLogout={onLogout} />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Navigate to={portalHome()} replace />} />
        {isSuperAdmin && <Route path="/admin" element={<Overview />} />}
        <Route path="/overview" element={<Navigate to={portalHome()} replace />} />
        {isSuperAdmin && <Route path="/users" element={<Teachers />} />}
        {isSuperAdmin && <Route path="/schools" element={<Schools />} />}
        {isSuperAdmin && <Route path="/centres" element={<Centres />} />}
        {isSuperAdmin && <Route path="/facilitators" element={<Facilitators />} />}
        {isSuperAdmin && <Route path="/admins" element={<AdminAccounts />} />}
        {isSuperAdmin && <Route path="/districts" element={<Districts />} />}
        {isSuperAdmin && <Route path="/structure" element={<Structure />} />}
        {/* PD days are authored here; modules live inside a PD day. */}
        <Route path="/pd-days" element={<PDDays />} />
        <Route path="/pd-days/:id" element={<PDDayDetail />} />
        <Route path="/modules" element={<Navigate to="/pd-days" replace />} />
        <Route path="/modules/:id" element={<ModuleRedirect />} />
        <Route path="/content" element={<Content />} />
        <Route path="/support" element={<SupportTickets />} />
        <Route path="/support/:ticketID" element={<SupportTickets />} />
        <Route path="/content/:id/questions" element={<QuizBuilder />} />
        <Route path="/content/:id/fields" element={<FormBuilder />} />
        <Route path="/content/:id/urdu" element={<ContentTranslation />} />
        {isSuperAdmin && <Route path="/schedule" element={<PDSessions />} />}
        {isSuperAdmin && <Route path="/exports" element={<Exports />} />}
        {isSuperAdmin && <Route path="/activity" element={<ActivityLog />} />}
        <Route path="*" element={<Navigate to={portalHome()} replace />} />
      </Route>
    </Routes>
  );
}
